export const textContentCardsStandaloneGql = /* GraphQL */ `
... on bodyContent2022_textContentCardsStandalone_BlockType {
    typeHandle
    eyebrow
    header
    description
    textAlign
    cardTheme
    roundedCorners
    colors
    imageDisplay:cardImageDisplay
    imageVariant:cardImageVariant
    cards:p2TCCards {
        ... on p2TCCards_BlockType {
            links:p2TCCardLinks
            description:p2TCDescription
            eyebrow:p2TCEyebrow
            title:p2TCTitle
            textAlign:p2TCTextAlign
            image:p2TCImage {
                ... on images_Asset {
                    title
                    sources:galleryEnlarged {
                        srcWebp
                        srcset
                    }
                    uncroppedSources:uncropped1920w {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;
